import axios from "./axios";

export const getTraders = async () => {
  const response = await axios.get("/api/users/traders/");
  return response.data;
};

export const createTrader = async (payload) => {
  const response = await axios.post("/api/users/traders/", payload);
  return response.data;
};

export const updateTrader = async (id, payload) => {
  const response = await axios.put(`/api/users/traders/${id}/`, payload);
  return response.data;
};

export const deleteTrader = async (id) => {
  const response = await axios.delete(`/api/users/traders/${id}/`);
  return response.data;
};

/** PUT — singular `trader` in path per backend */
export const changeTraderPassword = async (id, payload) => {
  const response = await axios.put(`/api/users/trader/${id}/change-password/`, payload);
  return response.data;
};
